import React from 'react';
import PropTypes from 'prop-types';
import { Menu, Dropdown } from 'antd';
import Button from '../../../Button';
import { LocalizationContext } from '../../../../hoc/Localization';
import styles from '../../TopBar/styles.less';

const CategoryFilter = ({ categories, category: propsCategory, pushFilters }) => {
  const { t } = React.useContext(LocalizationContext);
  const sortable = [];
  Object.keys(categories).forEach(value => {
    sortable.push([value, categories[value]]);
  });
  sortable.sort((a, b) => {
    if (a[1] > b[1]) {
      return 1;
    }
    if (b[1] > a[1]) {
      return -1;
    }
    return 0;
  });
  const menu = (
    <Menu defaultSelectedKeys={[propsCategory]}>
      {sortable.map(category => (
        <Menu.Item key={category[0]}>
          <a onClick={() => pushFilters({ category: category[0] })}>{t(categories[category[0]])}</a>
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <Button type="secondary" className={propsCategory ? styles.active : null}>
        {propsCategory ? categories[propsCategory] : t(categories[''])}
      </Button>
    </Dropdown>
  );
};

CategoryFilter.propTypes = {
  categories: PropTypes.object,
  category: PropTypes.string,
  pushFilters: PropTypes.func,
};

CategoryFilter.defaultProps = {
  categories: {
    '': 'search.category',
  },
  category: '',
  pushFilters: () => null,
};

export default CategoryFilter;
